import { createContext, useContext } from 'react'

import { MagazineArticleViewFragment } from '../fragments/MagazineArticleView.fragment.generated'
import { MagazineIssueViewFragment } from '../fragments/MagazineIssueView.fragment.generated'

type MagazineViewContextValue = {
    magazineIssue: MagazineIssueViewFragment
    articles: MagazineArticleViewFragment[] | null
}

const MagazineViewContext = createContext<MagazineViewContextValue | null>(null)

export const useMagazineView = () => {
    const context = useContext(MagazineViewContext)

    if (!context) {
        throw new Error(
            'useMagazineView must be used within MagazineViewProvider',
        )
    }
    return context
}

export const MagazineViewProvider = MagazineViewContext.Provider
